"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenancePageLayout = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const error40464_svg_1 = __importDefault(require("../../assets/icons/error40464.svg"));
const core_2 = require("../../core");
const MaintenancePageLayoutInteractor_1 = require("./MaintenancePageLayoutInteractor");
require("./types");
const Wrapper = styled_components_1.default.div `
  position: fixed;
  box-sizing: border-box;
  top: 50%;
  left: 50%;
  max-width: 500px;
  transform: translate(-50%, -75%);
`;
const Image = styled_components_1.default.i `
  display: block;
  overflow: hidden;
  padding: 0;
  margin: 0;
  background-color: transparent;
  background-image: ${({ src }) => (typeof src === 'string' ? `url(${src})` : '')};
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  width: 64px;
  min-height: 64px;
  height: 64px;
`;
const MaintenancePageLayout = ({ stateInfoLoadableModel, logOut, onCatchError, }) => {
    const { t } = core_2.useFeatureContext();
    core_1.useInteractor(() => {
        const presenters = {
            onLogOut: logOut,
            onCatchError,
        };
        return new MaintenancePageLayoutInteractor_1.MaintenancePageLayoutInteractor(stateInfoLoadableModel, presenters);
    });
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, indentHorizontal: components_1.INDENT.m, gap: components_1.STACK_GAP.m },
            react_1.default.createElement(Image, { src: error40464_svg_1.default }),
            react_1.default.createElement("div", null,
                react_1.default.createElement(components_1.TitleH1, null, t('maintenancePageLayout|title')),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(components_1.Text, null, t('maintenancePageLayout|description|row1')),
                    react_1.default.createElement(components_1.Text, null, t('maintenancePageLayout|description|row2')))))));
};
exports.MaintenancePageLayout = MaintenancePageLayout;
exports.MaintenancePageLayout.displayName = 'MaintenancePageLayout';
//# sourceMappingURL=MaintenancePageLayout.js.map